// import JSEncrypt from 'jsencrypt';

const apiResult = (apiData) => {
    const info = {};
    if (apiData) {
        if (apiData.error === 0 || apiData.error === '0') {
            info.message = apiData.message;
            info.error = 0;
            return false;
        }
        info.message = apiData.message ? apiData.message : '系统异常，请稍后再试';
        info.error = apiData.error;
        return info;
    }
    info.message = '系统异常，请稍后再试';
    info.msg = '系统异常，请稍后再试';
    info.error = null;
    return info;
};
export function apiError(apiData) {
    const info = {};
    if (!apiData || typeof apiData.apiError === 'undefined') {
        return apiResult(apiData);
    }
    if (apiData && apiData.data) {
        if (
            apiData.apiError === 0
            || apiData.apiError === '0'
            || apiData.error === 0
            || apiData.error === '0'
        ) {
            if (
                typeof apiData.data.error === 'undefined'
                || apiData.data.error === '0'
                || apiData.data.error === 0
                || apiData.data.result === 'success'
            ) {
                info.message = apiData.data.message;
                info.error = 0;
                return false;
            }
            info.message = apiData.data.message ? apiData.data.message : '系统异常，请稍后再试';
            info.redirectUrl = apiData.data.redirectUrl ? apiData.data.redirectUrl : '';
            info.error = apiData.data.error;
            return info;
        }
        info.message = '系统异常，请稍后再试';
        info.msg = '系统异常，请稍后再试';
        info.error = null;
        return info;
    }
    info.message = '系统异常，请稍后再试';
    info.msg = '系统异常，请稍后再试';
    info.error = null;
    return info;
}
export function isLoginNeed(path) {
    return false && path;
}
export function getToken() {
    const token = window.localStorage.getItem('X-TOKEN');
    return token || null;
}
export function getUser() {
    let user = {};
    const userStr = window.localStorage.getItem('USER_INFO');
    try {
        user = userStr ? JSON.parse(userStr) : {};
    } catch (e) {
        console.log(`get user error: ${userStr}`);
    }
    return user;
}
export function getCsrf() {
    const csrfParam = {};
    const paramsStr = window.localStorage.getItem('CLIENT_PARAMS');
    try {
        if (paramsStr) {
            const params = JSON.parse(paramsStr);
            csrfParam[params.csrf_header] = params.csrf;
        }
    } catch (e) {
        console.log(`get params error: ${paramsStr}`);
    }
    return csrfParam;
}
// export function rsaEncode(clearTxt) {
//     let publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCZgWn8I6Z/WxysLGCoIV3cbKiTLCaJa73i1zHfvXR4nFAt9aOYARZdxd8Ppu81Y1u8rV01vm/RMbSOuJlHPvxU2+DYnWLhXIG2xadBY9DxCT8qhUpHsqnkVd7zp3Awvm+WCDzcj5dcvO4cLZOpy9xRbAhY2NJ+NkafuX6zUiDPSQIDAQAB';
//     const paramsStr = window.localStorage.getItem('CLIENT_PARAMS');
//     try {
//         const params = JSON.parse(paramsStr);
//         publicKey = params.cipher_public;
//     } catch (e) {
//         console.log(`get params error: ${paramsStr}`);
//     }
//     const enc = new JSEncrypt();
//     enc.setPublicKey(publicKey);
//     const cipherTxt = enc.encrypt(clearTxt);
//     return cipherTxt;
// }
